module.exports = __webpack_public_path__ + "static/media/2-0.17ad561e.jpg";